import { baseApi } from "../redux/baseAPI";

export const shareDataApi = baseApi.injectEndpoints({
  tagTypes: ["ShareData"],
  endpoints: (builder) => ({
    getShareDataBatchList: builder.query({
      query: (data) => {
        return {
          url: `/share_data/batch_list.json`,
          method: "GET",
          params: data,
        };
      },
      providesTags: ["ShareData"],
      transformResponse: (response, meta, arg) => response,
    }),
    uploadAttachment: builder.mutation({
      query: (body) => {
        return {
          url: `/efax/upload_attachment.json`,
          method: "POST",
          data: body,
        };
      },
      transformResponse: (response, meta, arg) => response,
    }),
    AttachBillingData: builder.query({
      query: (param) => {
        return {
          url: `/billing/billing_summary_report.json`,
          method: "GET",
          params: param,
        };
      },
      transformResponse: (response, meta, arg) => response,
    }),
    patientClinicalView: builder.query({
      query: (param) => {
        return {
          url: `/PatientClinicals/view.json`,
          method: "GET",
          params: param,
        };
      },
      transformResponse: (response, meta, arg) => response,
    }),
    attachScreeningDataList: builder.query({
      query: (param) => {
        return {
          url: `/patient_forms/index.json`,
          method: "GET",
          params: param,
        };
      },
      transformResponse: (response, meta, arg) => response,
    }),
    reprocessingShareData: builder.mutation({
      query: (body) => {
        return {
          url: `/share_data/batch_reprocessing.json`,
          method: "POST",
          data: body,
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
    }),
    getAttachment: builder.query({
      query: (param) => {
        return {
          url: `/utilities/get_attachment.json`,
          method: "GET",
          params: param,
        };
      },
      transformResponse: (response, meta, arg) => response,
    }),
    prepareData: builder.mutation({
      query: (body) => {
        return {
          url: `/share_data/prepare_data.json?audit_encounter_id=${body?.encounter_id}`,
          method: "POST",
          data: body,
        };
      },
      transformResponse: (response, meta, arg) => response.response,
    }),
    getPatientShareTriageNotes: builder.query({
      query: (params) => ({
        url: "/patients/patient_share_triage_notes.json",
        method: "GET",
        params: params,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    printLabOrderFile: builder.mutation({
      query: (body) => ({
        url:
          body.mode == "order"
            ? `/labs/requisition_report.json`
            : `/labs/print_result.json`,
        method: "POST",
        params: {
          lab_order_id: body.id,
          skip_auto_accept: body.skip_auto_accept,
        },
      }),
      invalidatesTags: ["Result"],
      transformResponse: (response, meta, arg) => response.response,
    }),
    getRadiologyFileUid: builder.mutation({
      query: (body) => ({
        url: `/radiology/requisition_report.json`,
        method: "POST",
        params: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
    }),
    getRadiologyResult: builder.query({
      query: (body) => {
        return {
          url: `/radiology/orders.json`,
          method: "GET",
          params: { ...body },
        };
      },
      providesTags: ["Radiologyresult"],
      transformResponse: (response, meta, arg) => response?.response?.data,
    }),
    addDocumentLabLab: builder.mutation({
      query: ({ body, pid }) => {
        return {
          url: `/efax/upload_attachment.json`,
          method: "POST",
          headers: {
            "content-type": "multipart/form-data",
          },
          data: body,
          params: { pid: pid },
        };
      },
      // invalidatesTags: ['Result'],
      // invalidatesTags: ['ProviderNoteAPLabs'],
      transformResponse: (response, meta, arg) => response.response,
    }),
  }),
});

export const {
  useGetShareDataBatchListQuery,
  useUploadAttachmentMutation,
  useAttachBillingDataQuery,
  usePatientClinicalViewQuery,
  useAttachScreeningDataListQuery,
  useReprocessingShareDataMutation,
  useGetAttachmentQuery,
  usePrepareDataMutation,
  useGetPatientShareTriageNotesQuery,
  usePrintLabOrderFileMutation,
  useGetRadiologyFileUidMutation,
  useAddDocumentLabLabMutation,
} = shareDataApi;
// /support_providers/save.json
